import logoOffitel from 'assets/images/logo_offitel.png';
import logoCollapsedOffitel from 'assets/images/logo-collapsed_offitel.jpeg';

export type Brand = 'memo' | 'offitel';

export interface IBrandConfig {
  name: Brand;
  logo: string;
  logoCollapsed: string;
  primaryColor: string;
  darkBlue: string;
  companyName: string;
  companyUrl: string;
}

const memoBrand: IBrandConfig = {
  name: 'memo',
  logo: require('assets/images/logo.svg').default,
  logoCollapsed: require('assets/images/logo-collapsed.svg').default,
  primaryColor: '#2297f8',
  darkBlue: '#007da4',
  companyName: 'Memo NV',
  companyUrl: 'https://www.memo.be/',
};

const offitelBrand: IBrandConfig = {
  name: 'offitel',
  logo: logoOffitel,
  logoCollapsed: logoCollapsedOffitel,
  primaryColor: '#2297f8', // TODO: Update with offitel brand color
  darkBlue: '#007da4', // TODO: Update with offitel dark blue
  companyName: 'Offitel',
  companyUrl: 'https://www.offitel.be/',
};

const brandConfigs: Record<Brand, IBrandConfig> = {
  memo: memoBrand,
  offitel: offitelBrand,
};

// Toggle between 'memo' and 'offitel' for localhost brand
const LOCALHOST_BRAND: Brand = 'offitel';

/**
 * Detects the brand based on the current domain, query parameter, or localhost variable
 * For localhost testing, change LOCALHOST_BRAND above or use ?brand=memo or ?brand=offitel
 */
export const detectBrand = (): Brand => {
  // Check for query parameter first (for quick testing and Keycloak redirects)
  const urlParams = new URLSearchParams(window.location.search);
  const brandParam = urlParams.get('brand');
  if (brandParam === 'memo' || brandParam === 'offitel') {
    return brandParam;
  }

  // Use LOCALHOST_BRAND variable for localhost
  if (window.location.hostname.includes('localhost') || window.location.hostname === '127.0.0.1') {
    return LOCALHOST_BRAND;
  }

  // Detect based on hostname
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes('memoweb.be') || hostname.includes('memo.be')) {
    return 'memo';
  }

  if (hostname.includes('offiweb') || hostname.includes('offitel')) {
    return 'offitel';
  }

  // Default to memo
  return 'memo';
};

/**
 * Gets the current brand configuration
 */
export const getBrandConfig = (): IBrandConfig => {
  const brand = detectBrand();
  return brandConfigs[brand];
};

/**
 * Gets the current brand name
 */
export const getCurrentBrand = (): Brand => {
  return detectBrand();
};
